import { render, staticRenderFns } from "./DevGeneral.vue?vue&type=template&id=6120e377&scoped=true&"
import script from "./DevGeneral.vue?vue&type=script&lang=js&"
export * from "./DevGeneral.vue?vue&type=script&lang=js&"
import style0 from "./DevGeneral.vue?vue&type=style&index=0&id=6120e377&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120e377",
  null
  
)

export default component.exports